<template>
    <div>
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      background="#ababab"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide
        text="专业的软件解决方案"
        >
        <template #img>
          <img
            class="d-block img-fluid w-100"
            src="https://file.zhileit.com/202207/8C72DB177A69C2FA71A620881AAAA5B8.png"
            alt="image slot"
          >
        </template>
      </b-carousel-slide>
      <b-carousel-slide>
        <template #img>
          <img
            class="d-block img-fluid w-100"
            src="https://file.zhileit.com/202207/8DD994DD69B14E5BF2EFFC7F326AD677.jpg"
            alt="image slot"
          >
        </template>
      </b-carousel-slide>

    </b-carousel>
  </div>
</template>

<script>
    export default{
      name: 'HomeBanner',
        data() {
            return {
              slide: 0,
              sliding: null
            }
        },
        methods: {
          onSlideStart(slide) {
            this.sliding = true
          },
          onSlideEnd(slide) {
            this.sliding = false
          }
        }
    }
</script>
<style  lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/HomeBanner.vue